import { Box, Button, Container, Heading, Text, VStack } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiLogIn, FiUsers, FiMail } from 'react-icons/fi'
import { useProductTier } from '../hooks/useClientConfig'

/**
 * Public front door. Routes the two audiences that arrive at the root instance URL:
 * internal staff to the organizer sign-in, and canvassers to the shared-code join
 * flow (`/join`). Canvassers usually arrive via a link/QR the organizer sends, but a
 * canvasser told only the code — or anyone who lands on the bare instance URL — needs
 * a visible path here.
 */
export function HomePage() {
  const tier = useProductTier()
  return (
    <Container maxW="26rem" py={16}>
      <VStack gap={8} align="stretch">
        <Box textAlign="center">
          <Heading size="xl" mb={2}>Canvasser App</Heading>
          <Text color="fg.muted">How would you like to continue?</Text>
        </Box>

        <VStack gap={3} align="stretch">
          <Button asChild colorPalette="brand" size="lg" minH="44px">
            <RouterLink to="/join"><FiUsers />Join as a canvasser</RouterLink>
          </Button>
          <Button asChild variant="outline" size="lg" minH="44px">
            <RouterLink to="/login"><FiLogIn />Organizer / staff sign in</RouterLink>
          </Button>
          {/* [GI-10] Lobby-day attendee link recovery. UX-only gate — the server enforces
              RequiresUnionTier; shown only on a Union-tier instance. */}
          {tier === 'Union' && (
            <Button asChild variant="ghost" size="lg" minH="44px">
              <RouterLink to="/find-my-link"><FiMail />Lost your lobby day link?</RouterLink>
            </Button>
          )}
        </VStack>

        <Text fontSize="sm" color="fg.muted" textAlign="center">
          Canvassers: use the access code from your organizer, or the link they sent you.
        </Text>
      </VStack>
    </Container>
  )
}
